// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"tQ6UN4CtCykhSr7tap8lpw==","skuBanner":"zpQEsoRjL5BmxX+rw-pi4w=="};